(function () {
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var card = target.closest('product-card[data-product-id]');
      if (!card) return;

      var listContainer = card.closest('[data-ga-list-name]');
      if (!listContainer) return;

      var anchor = target.closest('a[href]');
      if (!anchor) {
        // v4c-search-batch 経由のカード (selection_for_you / reco_carousel) は
        // gallery が .product-card__link の外にあり、画像クリックの祖先に <a> が
        // いない。その場合は product-card 自身の navigateToProduct が JS 遷移
        // するので、同メソッドと同じ除外条件を満たすクリックだけを
        // カードの商品リンクにフォールバックして計測する
        if (card.hasAttribute('data-no-navigation')) return;
        if (target.closest('button, input, label, select, [tabindex="1"]')) return;
        anchor = card.querySelector('a[href*="/products/"]');
        if (!anchor) return;
      }

      var href = anchor.getAttribute('href') || '';
      if (href.indexOf('/products/') === -1) return;

      if (typeof window.gtag !== 'function') return;

      // GA4 / V4C 整合のため、Shopify Sales Channel と同じ
      // shopify_JP_{product_id}_{variant_id} 形式の id を送る (data-ga-item-id)
      var gaItemId = card.dataset.gaItemId || card.dataset.productId;

      window.gtag('event', 'select_item', {
        send_to: 'G-JTQB19HCBY',
        item_list_name: listContainer.dataset.gaListName,
        items: [{ item_id: gaItemId }],
      });
    },
    true
  );
})();
